export default "__VITE_ASSET__xsjVxd$N__"